var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoRadarGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2758_10050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75Z",
    stroke: "#4D525B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.53414 7.29012C4.34818 8.9179 3.81982 10.9331 4.05454 12.9334C4.28927 14.9336 5.26981 16.7718 6.8004 18.0808C8.33098 19.3898 10.299 20.0733 12.3114 19.9949C14.3239 19.9165 16.2328 19.082 17.6569 17.6579C19.081 16.2337 19.9156 14.3249 19.994 12.3124C20.0724 10.3 19.3888 8.33196 18.0798 6.80137C16.7708 5.27079 14.9327 4.29024 12.9324 4.05552C10.9321 3.82079 8.91692 4.34916 7.28914 5.53512",
    stroke: "#4D525B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70965 14.5005C7.25735 13.7266 7.023 12.8447 7.03147 11.9484C7.03994 11.052 7.29091 10.1747 7.75775 9.40947C8.2246 8.64425 8.88989 8.01969 9.68304 7.60206C10.4762 7.18444 11.3676 6.98932 12.2627 7.03743C13.1578 7.08554 14.0232 7.37507 14.767 7.8753C15.5108 8.37553 16.1053 9.06779 16.4875 9.87864C16.8696 10.6895 17.0251 11.5887 16.9375 12.4808C16.8498 13.3728 16.5223 14.2246 15.9897 14.9455M14.9247 16.0005C14.1454 16.5728 13.2159 16.9051 12.2504 16.9566C11.2849 17.0081 10.3254 16.7766 9.48965 16.2905",
    stroke: "#4D525B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9904 14.2152C13.2137 14.2152 14.2054 13.2235 14.2054 12.0002C14.2054 10.7768 13.2137 9.78516 11.9904 9.78516C10.7671 9.78516 9.77539 10.7768 9.77539 12.0002C9.77539 13.2235 10.7671 14.2152 11.9904 14.2152Z",
    stroke: "#4D525B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3457 7.59473C7.03606 7.59473 7.5957 7.03508 7.5957 6.34473C7.5957 5.65437 7.03606 5.09473 6.3457 5.09473C5.65535 5.09473 5.0957 5.65437 5.0957 6.34473C5.0957 7.03508 5.65535 7.59473 6.3457 7.59473Z",
    stroke: "#4D525B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52539 16.7148C9.21575 16.7148 9.77539 16.1552 9.77539 15.4648C9.77539 14.7745 9.21575 14.2148 8.52539 14.2148C7.83503 14.2148 7.27539 14.7745 7.27539 15.4648C7.27539 16.1552 7.83503 16.7148 8.52539 16.7148Z",
    stroke: "#4D525B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4551 16.2197C15.8693 16.2197 16.2051 15.8839 16.2051 15.4697C16.2051 15.0555 15.8693 14.7197 15.4551 14.7197C15.0409 14.7197 14.7051 15.0555 14.7051 15.4697C14.7051 15.8839 15.0409 16.2197 15.4551 16.2197Z",
    stroke: "#4D525B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2758_10050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRadarGray);
export default __webpack_public_path__ + "static/media/logo-radar-gray.c482e530500cac20f9f1a91647e9e492.svg";
export { ForwardRef as ReactComponent };